<template lang="pug">
	.iab-category-selector.flex-row.align-center.space
		Loader(v-if="isLoading", text="")
		template(v-else)
			EditableLabel.flex-1(ref="label", :editing="!selected.length", :disabled="disabled")
				span {{labelText}}
				template(slot="editor")
					DxDropDownBox.flex-1(
						ref="dropdown",
						:data-source="categories"
						:value="treeGridSelectedKeys",
						:defer-rendering="true"
						display-expr="Name"
						:show-clear-button="false"
						value-expr="Oid"			
						:dropDownOptions="{ minWidth: '320px', minHeight: '320px' }",
						@closed="$refs.label && $refs.label.release()"
					)
						template(:#content="{ data }")
							DxTreeList.iab-list(
								ref="iabCategories"
								:data-source="filteredCategories"
								:show-borders="false"
								:column-auto-width="true"
								:word-wrap-enabled="true"
								:expanded-row-keys="expandedRowKeys"
								:selected-row-keys="treeGridSelectedKeys"
								:showColumnHeaders="false"
								height="320px"
								width="100%"
								key-expr="Oid"
								parent-id-expr="ParentId"
								@selectionChanged="selectionChanged"
							)
								DxSearchPanel(:visible="true", :width="335", :placeholder="$tCaption('Start typing or scroll through interests below')")
								DxHeaderFilter(:visible="true")
								DxSelection(mode="multiple", :recursive="true")
								DxColumnChooser(:enabled="false")
								DxColumn(:width="400", data-field="Name")
		Loader(v-if="isSaving", text="")
</template>

<script>
	import DxDropDownBox from 'devextreme-vue/drop-down-box';
	import {
		DxTreeList,
		DxColumn,
		DxColumnChooser,
		DxHeaderFilter,
		DxSearchPanel,
		DxSelection,
		DxLookup
	} from 'devextreme-vue/tree-list';
	import Loader from 'app-core/Loader.vue';
	import EditableLabel from 'app-core/EditableLabel.vue';

	export default {
		translationCategory: 'iabCategory.selector',
		name: 'iab-category-selector',
		components: {
			DxDropDownBox,
			DxTreeList,
			DxColumn,
			DxColumnChooser,
			DxHeaderFilter,
			DxSearchPanel,
			DxSelection,
			DxLookup,
			Loader,
			EditableLabel
		},
		props: ['parentCategoryCode', 'objectId', 'objectTypeId', 'disabled'],
		data() {
			return {
				categories: [],
				selected: [],
				expandedRowKeys: [],
				isLoading: 0,
				isSaving: 0
			};
		},
		computed: {
			treeGridSelectedKeys() {
				return this.selected.map(f => f.Oid);
			},
			filteredCategories() {
				const codes = this.parentCategoryCode && (Array.isArray(this.parentCategoryCode) ? this.parentCategoryCode : [this.parentCategoryCode]) || [];
				const parentIds = this.categories.filter(f => codes.find(c => c == f.Code)).map(f => f.Oid);
				if (__DEBUG__)
					console.debug('FilteredCategories', { codes, parentIds });
				if (parentIds.length) {					
					return this.categories.filter(f => parentIds.includes(f.ParentId)).map(f => ({
						...f,
						ParentId: null
					}));
				}
				return this.categories;
			},
			labelText() {
				return this.selected.map(f => f.Name).join(', ') || this.$tCaption('Edit', '@actions');
			}
		},
		watch: {
			objectId() {
				this.loadSelectedCategories();
			},
			selected(v) {
				this.$emit('selected', v);
			}
		},
		mounted() {
			this.loadCategoriesList();
			this.loadSelectedCategories();
			if (__DEBUG__)
				window.iabCategoriesSelector = this;
			this.$processSelection = _.debounce(this.processSelection, 2000, {
				'leading': false,
				'trailing': true
			});
		},
		destroyed() {
			delete this.$lastSelectedIds;
		},
		methods: {
			selectionChanged(e) {
				if (!this.categories?.length) return;
				if (__DEBUG__)
					console.log('Selection changed', e);				
				const selectedRowKeys = this.$refs.iabCategories.instance.getSelectedRowKeys('all').map(f => f.Oid || f);
				this.selected = this.categories.filter(f => selectedRowKeys.includes(f.Oid));
				this.$processSelection();
			},
			loadCategoriesList() {
				this.isLoading++;
				this.$Data.loadIabCategories().then(r => {
					this.categories = _.orderBy(r, ['Name']);
				}).finally(() => this.isLoading--);
			},
			loadSelectedCategories() {
				this.isLoading++;
				this.$lastSelectedIds = [];
				this.$Data.getExternalApi('IabCategory/GetIabCategoriesByObject', `objectId=${this.objectId}&objectType=${this.objectTypeId}`).then(r => {
					this.selected = r;
					this.$lastSelectedIds = r.map(f => f.Oid);
				}).finally(() => this.isLoading--);
			},
			processSelection() {
				let newIds = this.selected.filter(f => !this.$lastSelectedIds.includes(f.Oid)).map(f => f.Oid);
				let removedIds = this.$lastSelectedIds.filter(f => !this.selected.find(s => s.Oid === f));

				if (__DEBUG__)
					console.debug('Process selection', { newIds, removedIds });

				if (newIds.length) {
					this.isSaving++;
					this.$Data.postExternalApi('IabCategory/LinkIabCategories', {
						LinkToObjectId: this.objectId,
						LinkToObjectType: this.objectTypeId,
						IabCategoryIds: newIds
					}).finally(() => this.isSaving--);
				}

				if (removedIds.length) {
					this.isSaving++;
					this.$Data.postExternalApi('IabCategory/UnlinkIabCategories', {
						LinkToObjectId: this.objectId,
						LinkToObjectType: this.objectTypeId,
						IabCategoryIds: removedIds
					}).finally(() => this.isSaving--);
				}

				this.$lastSelectedIds = this.selected.map(f => f.Oid);
			},
			selectByName(name) {
				this.selected = this.categories.filter(f => f.Name === name);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.iab-category-selector {

	}
</style>
 